import OCTRenderQueue from '../../plugins/oct-render-queue'

const $_prefix = 'oct-scroll-into-view'

class OCTScrollIntoView {
  constructor (el, params={offset:0}) {
    if (el.__OCTScrollIntoView) return this

    this.el = el
    this.offset = params.offset || 0

    window.addEventListener('scroll', () => this.$_scrollHandler())

    this.el.classList.add($_prefix + '--init')
    this.el.__OCTScrollIntoView = this

    this.$_scrollHandler()
  }

  $_scrollHandler () {
    const height = window.innerHeight
    const rect = this.el.getBoundingClientRect()

    if (rect.bottom < 0)
      return

    if (rect.top > height)
      OCTRenderQueue.push(() => this.el.classList.remove('oct-in-view'))
    else if (height - rect.top > height*this.offset)
      OCTRenderQueue.push(() => this.el.classList.add('oct-in-view'))
  }
}

if (process.env.NODE_ENV === 'development')
  console.info('[OCT] Intializing OCTScrollIntoView...')

export default OCTScrollIntoView
